var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "scoped-autocomplete-input-container",
      class: _vm.itemClass
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input,
            expression: "input"
          }
        ],
        staticClass: "form-control",
        class: _vm.inputClass,
        attrs: { type: "text" },
        domProps: { value: _vm.input },
        on: {
          keydown: _vm.processKeyPress,
          focus: function($event) {
            _vm.showDropdown = true
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.input = $event.target.value
          }
        }
      }),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDropdown,
              expression: "showDropdown"
            }
          ],
          staticClass: "scoped-autocomplete-list",
          style: { height: _vm.currentItemsHeight }
        },
        _vm._l(_vm.filteredList, function(item, i) {
          return _c(
            "li",
            {
              key: "autocomplete-" + i,
              staticClass: "scoped-autocomplete-list-item",
              class: _vm.selectedIndex == i ? "selected" : "",
              on: {
                click: function($event) {
                  return _vm.itemSelected(item)
                },
                mouseover: function($event) {
                  _vm.selectedIndex = i
                }
              }
            },
            [
              _vm._v(
                "\n            " + _vm._s(item[_vm.showKey]) + "\n        "
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }